<template>
    <div class="container">
        <div class="empty-list" v-if="!messages || messages.length == 0">{{ $t("admin.overview.message_center.no_unread_messages") }}</div>
        <ul>
            <li class="message-container" v-for="message of messages" v-bind:key="message.id">
                <img class="message-icon" v-bind:src="messageIcon(message)" />
                <a class="message-title" :href="messageUrl(message)" target="_blank">{{ messageTitle(message) }}</a>
                <div class="message-message">{{ messageContent(message) }}</div>
                <div class="message-received-date">{{ $t("admin.message_center.received_on") }} {{ messageReceivedDate(message) }}</div>
                <div class="message-actions">
                    <button class="btn btn-outline-primary btn-sm" v-if="!message.read && !message.deleted" v-on:click="handleMarkAsReadButtonClicked(message)">{{ $t("admin.message_center.mark_as_read_button") }}</button>
                </div>
            </li>
        </ul>

        <div class="bottom-toolbar">
            <router-link to="/admin/messagecenter">{{ $t("admin.overview.message_center.show_more") }}</router-link>
        </div>
    </div>    
</template>

<script>
import MessagingService from "@/service/MessagingService.js"
import LangUtils from "@/utils/LangUtils.js"
import * as moment from 'moment';

export default {
    data() {
        return {
            currentUser: this.$store.state.currentUser,
            messagingService: new MessagingService(),
            messages: null
        }
    },

    props: {
        publisherId: String,
        userId: String
    },
    
    watch: {
        publisherId: function(newValue, oldValue) {
            if (newValue != oldValue) {
                this.loadMessages();
            }
        }
    },

    methods: {
        loadMessages() {
            this.messagingService.loadMessagesForUser(this.userId, this.publisherId, true).then((messages) => {
                this.messages = messages;
            }).catch((error) => {
                console.log(error);
            });
        },

        messageIcon(message) {
            if (message.type == "emergency") {
                return require("@/assets/icons/EmergencyIcon.png");
            } else if (message.type == "terrain_report") {
                return require("@/assets/icons/TerrainReportIcon.png");
            } else {
                return require("@/assets/icons/MessageIcon.png");
            }
        },

        messageTitle(message) {
            return LangUtils.valueForLanguage(message.getTitle(), this.$i18n.locale);
        },

        messageContent(message) {
            return LangUtils.valueForLanguage(message.getMessage(), this.$i18n.locale);
        },

        messageUrl(message) {
            return LangUtils.valueForLanguage(message.getActionUrl(), this.$i18n.locale);
        },

        messageReceivedDate(message) {
            return LangUtils.valueForLanguage(
                moment(new Date(message.getReceivedDate())).format("YYYY-MM-DD hh:mm"), this.$i18n.locale);
        },

        handleMarkAsReadButtonClicked(message) {
            message.read = true;
            this.messagingService.saveMessageForUser(this.currentUser.uid, message).then(() => {
                this.loadMessages();
            }).catch((error) => {
                console.log(error);
            });
        }
    },

    mounted() {
        this.loadMessages();
    }    
}
</script>

<style scoped>
.container {
    text-align: left;
    padding: 0px;
}

ul {
    list-style: none;
    padding: 0px;
}

li {
    margin-top: 8px;
}

.empty-list {
    color: #777777;
    font-size: 18px;
    font-weight: bold;
    margin: 32px 0px;
    text-align: center;
}

.message-container {
    display: grid;
    grid-template-columns: 38px auto auto;
    grid-template-rows: auto auto auto;
    grid-template-areas: "icon title title" "icon message message" "icon receivedDate actions";
    margin-bottom: 16px;
}

.message-icon {
    grid-area: icon;
    width: 30px;
}

.message-title {
    grid-area: title;
    display: block;
    font-weight: bold;
}

.message-message {
    grid-area: message;
    color: #555555;
    font-size: 14px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical; 
}

.message-received-date {
    grid-area: receivedDate;
    color: #999999;
    font-size: 12px;
    align-self: center;
}

.message-actions {
    grid-area: actions;
    justify-self: right;
}
</style>